import { Routes } from '@angular/router';

export const routes: Routes = [
    {
       path:'', redirectTo: 'home', pathMatch: 'full'
    },
    {
        path: 'home',
        loadComponent: () => import('./home/home').then(m => m.Home), title: "Home"
    },
{
        path: 'products',
        loadComponent: () => import('./product/product').then(m => m.Product), title: "Product"
    },
    {
        path: 'products/:id',
        loadComponent: () => import('./product/product').then(m => m.Product), title: "Product"
    },
    {
        path: 'gallery',
        loadComponent: () => import('./gallery/gallery').then(m => m.Gallery), title: "Gallery"
    },
    {
        path: 'about',
        loadComponent: () => import('./about/about').then(m => m.About), title: "About"
    },
    {
        path: 'contact',
        loadComponent: () => import('./contact/contact').then(m => m.Contact), title: "Contact"
    },
    {
        path: '**',
      redirectTo: 'home', pathMatch: 'full'
    },
];
